import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

function Welcome() {
  const directoReact = () => {
    window.open("https://react.dev/", "_blank");
  };
  const divertToPlay = () => {
    window.open(
      "https://open.spotify.com/playlist/37i9dQZF1DX8NTLI2TtZa6",
      "_blank"
    );
  };
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(true);
  }, []);

  return (
    <div id="deco">
      <div className="container" id="fancy">
        <h1 id="welcome" className={show ? "show" : ""}>
          Welcome to
          <u className="mx-2">iNotes</u>
        </h1>
      </div>
      <div className="container">
        <h3 className="my-4">your minimalistic note-taking experience.</h3>
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            id="airpods"
            src="airpods.png"
            alt=""
            className={`${show ? "show" : ""} my-3`}
            style={{ float: "right", marginRight: "10px" }}
          />
          <h3 className="">
            Experience the best focus playlist while taking notes.{" "}
            <b>
              <u type="button" onClick={divertToPlay}>
                <i id="musictag">listen</i>
              </u>
            </b>
          </h3>
        </div>
      </div>
      <div>
        <Link
          id="create"
          className="nav-link active mx-5 my-2"
          aria-current="page"
          to="/Signup"
        >
          Create ID
        </Link>
        {/* <Link
          id="create"
          className="nav-link active mx-5 my-2"
          aria-current="page"
          to="/text"
        >
          Create
        </Link> */}
      </div>
      <div id="powercont" className="container my-3">
        <p id="power">
          <b>Powered By React</b>{" "}
          <img
            type="button"
            id="reactlogo"
            src="logo192.png"
            alt=""
            className="mx-2"
            onClick={directoReact}
          />
        </p>
      </div>
    </div>
  );
}

export default Welcome;
